import { QueryClient } from '@tanstack/react-query';

// TanStack Query 分层默认（对齐 CLAUDE.md §四 + fzy-know「D1 高行读取优化」§2.2）
// - Dashboard 60s/60s（KB §2.2：Overview 60s 起步；30s 会把 D1 reads 顶到免费线）
// - Inbox 30s（比通知实时性够用，不必比通知更新）
// - 别名/规则 60s/off
// - refetchIntervalInBackground: false：隐藏标签页不烧数据库（KB §2.2 明文要求）
// 每个 useQuery 可覆盖
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        retry: 1,
      },
    },
  });
}

// 该客户端仅用于身份查询；私有数据使用 SessionQueryProvider 内的独立客户端。
export const queryClient = createQueryClient();
